import { render, staticRenderFns } from "./statistics.page.vue?vue&type=template&id=663494a3&scoped=true"
import script from "./statistics.page.vue?vue&type=script&lang=js"
export * from "./statistics.page.vue?vue&type=script&lang=js"
import style0 from "./statistics.page.vue?vue&type=style&index=0&id=663494a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663494a3",
  null
  
)

export default component.exports